<template lang="pug">
    v-stepper(v-model="step")
        v-stepper-header
            v-stepper-step( :complete="completeGeneral" step="1" :color="completeGeneral && this.date ? 'green' : 'primary'" ) Info. General
            v-divider
            v-stepper-step( :complete="completeTaxable" step="2" :color="completeTaxable ? 'green' : 'primary'" ) Rentas Imponibles
            v-divider
            //v-stepper-step( :complete="completeAPV" step="3" :color="completeAPV ? 'green' : 'primary'" ) Info. APV
            //v-divider
            v-stepper-step( :complete="completeAFC" step="4" :color="completeAFC ? 'green' : 'primary'" ) Info. AFC
        v-stepper-items
            v-stepper-content( class="elevation-0" step="1" )
                v-flex( xs11 sm5 )
                    v-dialog.ml-5.mt-4.mb-2(
                        ref="dialog"
                        v-model="modal"
                        
                        persistent
                        lazy
                        full-width
                        width="290px"
                        )
                        v-text-field(
                            slot="activator"
                            v-model="date"
                            label="Indique Período"
                            prepend-icon="event"
                            readonly
                            )
                        v-date-picker(v-model="date" type="month" scrollable locale)
                        v-spacer
                        //v-btn(flat color="primary" @click="modal = false") Cancel
                        //v-btn(flat color="primary" @click="submitDate") OK
                crud-form(v-bind="generalFormProps" @calculate="calculateGeneralForm" @submitForm="submitGeneralForm")
                v-btn.ma-4( color="primary" large @click="goToStepTwo") Siguiente
                    v-icon navigate_next
            v-stepper-content( class="elevation-0" step="2" )
                crud-form( v-bind="taxableFormProps" @calculate="calculateTaxableForm" @submitForm="submitTaxableForm")
                v-btn.ma-4( dark large @click="goBackToStepOne") Anterior
                    v-icon navigate_before
                v-btn.ma-4( color="primary" large @click="goToStepThree") Siguiente
                    v-icon navigate_next
            v-stepper-content( class="elevation-0" step="3" )
                crud-form( v-bind="apvFormProps" @calculate="calculateAPVForm" @submitForm="submitAPVForm")
                v-btn.ma-4( dark large @click="goBackToStepTwo") Anterior
                    v-icon navigate_before
                v-btn.ma-4( color="primary" large @click="goToStepFour") Siguiente
                    v-icon navigate_next
            v-stepper-content( class="elevation-0" step="4" )
                v-alert( color='info' icon='info' :value='true' )
                    h1.title.text-uppercase.mb-2 Seguro de cesantía por tipo de contrato
                    h4.body-2.text-uppercase C.I. = Contrato Indefinido
                    h4.body-2.text-uppercase C.F. = Contrato Fijo
                //- v-toolbar( color="blue darken-4" dark sticky flat height='108' )
                    v-toolbar-title
                        span.title Seguro de cesantía por tipo de contrato
                        v-spacer
                        span.body-2 C.I. = Contrato Indefinido
                        v-spacer
                        span.body-2 C.F. = Contrato Fijo
                crud-form( v-bind="afcFormProps" @calculate="calculateAFCForm" @submitForm="submitAFCForm")
                v-btn.ma-4( dark large @click="goBackToStepThree") Anterior
                    v-icon navigate_before
</template>

<script>
//-
import { mapActions, mapState } from 'vuex'
import { CrudForm } from '@/components/reusable_components'
import {
    FieldsShowAFC,
    FieldsShowAPV,
    FieldsShowGeneralInfo,
    FieldsShowTaxableRent,
} from './fields'
import {
    fetchById,
    generatePrevisionIndicator,
} from '@/services/api/previsionIndicators'
import moment from 'moment'
//-
export default {
    name: 'details-prevision-indicators',
    // props: {},
    data: function() {
        return {
            date: null,
            menu: false,
            modal: false,
            step: 1,
            completeGeneral: false,
            completeTaxable: false,
            completeAPV: false,
            completeAFC: false,
            fieldsShowGeneralInfo: FieldsShowGeneralInfo,
            fieldsShowTaxableRent: FieldsShowTaxableRent,
            fieldsShowAPV: FieldsShowAPV,
            fieldsShowAFC: FieldsShowAFC,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        generalFormProps() {
            return {
                fields: this.fieldsShowGeneralInfo,
                editable: this.$can('EDIT_PREVISION_INDICATOR'),
                readOnly: !this.$can('EDIT_PREVISION_INDICATOR'),
                submitText: 'Guardar',
                ref: 'refShowGeneralForm',
            }
        },
        taxableFormProps() {
            return {
                fields: this.fieldsShowTaxableRent,
                editable: this.$can('EDIT_PREVISION_INDICATOR'),
                readOnly: !this.$can('EDIT_PREVISION_INDICATOR'),
                submitText: 'Guardar',
                ref: 'refShowTaxableForm',
            }
        },
        apvFormProps() {
            return {
                fields: this.fieldsShowAPV,
                editable: this.$can('EDIT_PREVISION_INDICATOR'),
                readOnly: !this.$can('EDIT_PREVISION_INDICATOR'),
                submitText: 'Guardar',
                ref: 'refShowAPVForm',
            }
        },
        afcFormProps() {
            return {
                fields: this.fieldsShowAFC,
                editable: this.$can('EDIT_PREVISION_INDICATOR'),
                readOnly: !this.$can('EDIT_PREVISION_INDICATOR'),
                submitText: 'Guardar',
                ref: 'refShowAFCForm',
            }
        },
    },
    methods: {
        // -- Data fetching
        getPrevisionIndicatorInfo: async function() {
            let response = await fetchById(this.$route.params.id)
            this.fillFields(response)
            this.makeValidFields()
        },
        // -- Fill fields
        fillFields: function(data) {
            // -- General Fields
            let dateData = data.period_year + '-' + data.period_month
            this.date = moment(dateData).format('YYYY-MM')
            this.fieldsShowGeneralInfo[0].value = parseFloat(data.uf)
            this.fieldsShowGeneralInfo[1].value = parseFloat(data.utm)
            this.fieldsShowGeneralInfo[2].value = parseFloat(data.uta)
            this.fieldsShowGeneralInfo = [...this.fieldsShowGeneralInfo]
            // -- Taxable Rent Fields
            this.fieldsShowTaxableRent[0].value = parseFloat(data.max_afp_uf)
            this.fieldsShowTaxableRent[1].value = parseFloat(data.max_fonasa_uf)
            this.fieldsShowTaxableRent[2].value = parseFloat(data.max_health_uf)
            this.fieldsShowTaxableRent[3].value = parseFloat(data.max_unemployment_insurance_uf)
            this.fieldsShowTaxableRent[4].value = parseFloat(data.imm)
            this.fieldsShowTaxableRent[5].value = parseFloat(data.max_apv_monthly_uf)
            this.fieldsShowTaxableRent[6].value = parseFloat(data.max_apv_yearly_uf)
            this.fieldsShowTaxableRent = [...this.fieldsShowTaxableRent]
            // -- APV Fields
            //this.fieldsShowAPV[0].value = parseInt(data.max_apv_monthly_uf)
            //this.fieldsShowAPV[1].value = parseInt(data.max_apv_yearly_uf)
            //this.fieldsShowAPV = [...this.fieldsShowAPV]
            // -- AFC Fields
            this.fieldsShowAFC[0].value =
                data.porc_afc_employer_undefined_contract
            this.fieldsShowAFC[1].value =
                data.porc_afc_worker_undefined_contract
            this.fieldsShowAFC[2].value = data.porc_afc_employer_fixed_contract
            this.fieldsShowAFC[3].value = data.porc_afc_worker_fixed_contract
            this.fieldsShowAFC[4].value =
                data.porc_afc_employer_undefined_contract_min_eleven_years
            this.fieldsShowAFC[5].value =
                data.porc_afc_worker_undefined_contract_min_eleven_years
            this.fieldsShowAFC = [...this.fieldsShowAFC]
        },
        // -- UI Modification
        makeValidFields: function() {
            this.completeGeneral = true
            this.completeTaxable = true
            this.completeAPV = true
            this.completeAFC = true
        },
        submitDate: function() {
            this.$refs.dialog.save(this.date)
            this.data = this.$refs.dialog.$options.propsData.returnValue
        },
        submitGeneralForm: function() {
            this.saveSnackbarMessage()
        },
        submitTaxableForm: function() {
            this.saveSnackbarMessage()
        },
        submitAPVForm: function() {
            this.saveSnackbarMessage()
        },
        submitAFCForm: function() {
            this.saveSnackbarMessage()
        },
        saveSnackbarMessage() {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Guardar')
            let payload = this.fillSnack(
                'warning',
                '¿Desea guardar los cambios?',
                ''
            )
            this.initSnackbar(payload)
        },
        // -- Navegations on Steppers
        goToStepTwo: function() {
            let vmodelsGeneral = this.$refs.refShowGeneralForm.vmodels
            if (
                this.date !== null &&
                vmodelsGeneral.uf !== '' &&
                vmodelsGeneral.uta !== '' &&
                vmodelsGeneral.utm !== ''
            ) {
                this.step = 2
            } else if (this.date === null || this.date === '') {
                this.showSnackbar('info', 'Acción inválida', 'Ingrese período')
            } else {
                this.showSnackbar(
                    'info',
                    'Acción inválida',
                    'Complete todos los campos'
                )
            }
        },
        goToStepThree: function() {
            let vmodelsTaxableRent = this.$refs.refShowTaxableForm.vmodels
            if (
                vmodelsTaxableRent.max_afp_uf !== '' &&
                vmodelsTaxableRent.max_fonasa_uf !== '' &&
                vmodelsTaxableRent.max_health_uf !== '' &&
                vmodelsTaxableRent.max_unemployment_insurance_uf !== '' &&
                vmodelsTaxableRent.max_apv_monthly_uf !== '' &&
                vmodelsTaxableRent.max_apv_yearly_uf !== '' &&
                vmodelsTaxableRent.imm !== ''
            ) {
                this.step = 4
            } else {
                this.showSnackbar(
                    'info',
                    'Acción inválida',
                    'Complete todos los campos'
                )
            }
        },
        goToStepFour: function() {
            let vmodelsAPV = this.$refs.refShowAPVForm.vmodels
            if (
                vmodelsAPV.max_apv_monthly_uf !== '' &&
                vmodelsAPV.max_apv_yearly_uf !== ''
            ) {
                this.step = 4
            } else {
                this.showSnackbar(
                    'info',
                    'Acción inválida',
                    'Complete todos los campos'
                )
            }
        },
        goBackToStepOne() {
            this.step = 1
        },
        goBackToStepTwo() {
            this.step = 2
        },
        goBackToStepThree() {
            this.step = 2
        },
        // -- Data handling and transformations
        // -- Calculate methods for Validations
        calculateGeneralForm: function() {
            this.completeGeneral = this.$refs.refShowGeneralForm.$refs.form.validate()
        },
        calculateTaxableForm: function() {
            this.completeTaxable = this.$refs.refShowTaxableForm.$refs.form.validate()
        },
        calculateAPVForm: function() {
            this.completeAPV = this.$refs.refShowAPVForm.$refs.form.validate()
        },
        calculateAFCForm: function() {
            this.completeAFC = this.$refs.refShowAFCForm.$refs.form.validate()
        },
        // -- Validations and Error handling
        showSnackbar: function(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
        // -- Other functions
        // -- Vuex mappings
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        async responseConfirm(val) {
            //-
            if (val === 'Guardar') {
                this.resetSnackbarState()
                let obj = {}
                // -- Datos Generales
                let vmodelsGeneral = this.$refs.refShowGeneralForm.vmodels
                obj.uf = vmodelsGeneral.uf
                obj.utm = vmodelsGeneral.utm
                obj.uta = vmodelsGeneral.uta
                // -- Rentas Imponibles
                let vmodelsTaxableRent = this.$refs.refShowTaxableForm.vmodels
                obj.max_afp_uf = vmodelsTaxableRent.max_afp_uf
                obj.max_fonasa_uf = vmodelsTaxableRent.max_fonasa_uf
                obj.max_health_uf = vmodelsTaxableRent.max_health_uf
                obj.max_unemployment_insurance_uf =
                    vmodelsTaxableRent.max_unemployment_insurance_uf
                obj.imm = vmodelsTaxableRent.imm
                obj.max_apv_monthly_uf = vmodelsTaxableRent.max_apv_monthly_uf
                obj.max_apv_yearly_uf = vmodelsTaxableRent.max_apv_yearly_uf
                // -- APV
                //let vmodelsAPV = this.$refs.refShowAPVForm.vmodels
                //obj.max_apv_monthly_uf = vmodelsAPV.max_apv_monthly_uf
                //obj.max_apv_yearly_uf = vmodelsAPV.max_apv_yearly_uf
                // -- AFC
                let vmodelsAFC = this.$refs.refShowAFCForm.vmodels
                obj.porc_afc_employer_undefined_contract =
                    vmodelsAFC.porc_afc_employer_undefined_contract
                obj.porc_afc_worker_undefined_contract =
                    vmodelsAFC.porc_afc_worker_undefined_contract
                obj.porc_afc_employer_fixed_contract =
                    vmodelsAFC.porc_afc_employer_fixed_contract
                obj.porc_afc_worker_fixed_contract =
                    vmodelsAFC.porc_afc_worker_fixed_contract
                obj.porc_afc_employer_undefined_contract_min_eleven_years =
                    vmodelsAFC.porc_afc_employer_undefined_contract_min_eleven_years
                obj.porc_afc_worker_undefined_contract_min_eleven_years =
                    vmodelsAFC.porc_afc_worker_undefined_contract_min_eleven_years
                // -- Period Year & Month
                let periodYear = parseFloat(this.date.substr(0, 4))
                let periodMonth = parseFloat(this.date.substr(5, 2))
                let response = await generatePrevisionIndicator(
                    obj,
                    periodYear,
                    periodMonth
                )
                //-
                if (response.status == 'success') {
                    let payload = this.fillSnack(
                        'success',
                        'Indicadores previsionales actualizados correctamente',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.$router.push('/prevision_indicators')
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'crud-form': CrudForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    mounted: function() {
        this.setTitleTopBar('Detalle de indicadores previsionales')
        this.getPrevisionIndicatorInfo()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PREVISION_INDICATOR'))
                ctx.$router.push('/')
        })
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>